





























import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import accountMixin from './profileMixin'

export default mixins(accountMixin, mobileTypeMixin).extend({})
